'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const QUERY = '(prefers-reduced-motion: reduce)';
export function usePrefersReducedMotion() {
  const $ = _c(2);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQuery = window.matchMedia(QUERY);
      const handler = function handler(event) {
        setPrefersReducedMotion(event.matches);
      };
      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return prefersReducedMotion;
}
function _temp() {
  if (typeof window === "undefined") {
    return false;
  }
  return window.matchMedia(QUERY).matches;
}